import styled from "styled-components";

import { media } from "../../../../../styles/media";

export const CompleteStyles = styled.section`
  width: 100%;
  max-width: 960px;
  background: ${({ theme }) => theme.colors.semantic.container.white};
  box-shadow: ${({ theme }) => theme.shadows.card};
  border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
  border-radius: ${({ theme }) => theme.radius[16]};
  overflow: hidden;

  .ob-complete-hero {
    padding: 26px 28px;
    display: flex;
    align-items: center;
    gap: 20px;
    background: linear-gradient(
      180deg,
      ${({ theme }) => theme.colors.success[50]},
      ${({ theme }) => theme.colors.semantic.container.white}
    );
  }

  .ob-complete-check {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.success[600]};
    color: ${({ theme }) => theme.colors.semantic.accent.onAccent};
    display: grid;
    place-items: center;
    flex-shrink: 0;
    box-shadow: 0 6px 16px rgba(67, 160, 60, 0.35);
  }

  .ob-complete-main {
    flex: 1;
    min-width: 0;
  }

  .ob-complete-title {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.3px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .ob-complete-desc {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.primary[500]};
    margin-top: 4px;
  }

  .ob-complete-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-end;
    flex-shrink: 0;
  }

  .ob-complete-rec {
    padding: 18px 28px 22px;
    border-top: 1px solid ${({ theme }) => theme.colors.semantic.separator};

    .ob-complete-rec-title {
      font-size: 13px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      margin-bottom: 4px;

      .muted {
        color: ${({ theme }) => theme.colors.primary[400]};
        font-weight: 400;
      }
    }
  }

  ${media.maxMobile`
    .ob-complete-hero {
      flex-direction: column;
      align-items: flex-start;
      padding: 20px 18px;
    }
    .ob-complete-actions {
      align-items: stretch;
      width: 100%;
    }
    .ob-complete-rec { padding: 16px 18px 20px; }
  `}
`;
